import React, { ChangeEvent } from 'react';
import { ProductListAdType } from '@api/graphql/types';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';

interface Props {
    name: string;
    value: ProductListAdType;
    placeholder?: string;
    hint?: string;
    onChangeHandler: (value: ProductListAdType, name: string) => void;
}

interface State {
    value: ProductListAdType;
}

class ProductListAdTypeSelect extends React.Component<Props & InjectedIntlProps, State> {

    public state = {
        value: ProductListAdType.BANNER,
    };

    public componentDidMount() {
        this.setState({value: this.props.value});
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({value: props.value});
    }

    public render() {
        return (
            <>
                <select
                    name={this.props.name}
                    value={this.state.value}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => { this.props.onChangeHandler((e.currentTarget.value as ProductListAdType), this.props.name); }}
                    className="form-control"
                >
                    <option value={ProductListAdType.BANNER}>{this.props.intl.formatMessage({ id: "module.productListAd.productAdListType.banner" })}</option>
                    <option value={ProductListAdType.PRODUCT}>{this.props.intl.formatMessage({ id: "module.productListAd.productAdListType.product" })}</option>
                </select>
                {this.props.hint && <span className="form-text m-b-none">{this.props.hint}</span>}
            </>
        );
    }
}

export default compose(
    injectIntl,
)(ProductListAdTypeSelect);



// WEBPACK FOOTER //
// ./src/components/Form/ProductListAdTypeSelect.tsx